@if (currentSlide && slideTypeCategory) {
  @if (slideTypeCategory === 'canvas') {
    @if (isPerceptionImage) {
      <pcp-perception-slide
        [slide]="currentSlide"
        [layer]="fabricLayer"
        [drawingTool]="activeDrawingTool"
        [isPresentationScreen]="isPresentationScreen"
        [revealed]="perceptionRevealed"
        [showEpoch]="perceptionShowEpoch"
        (reveal)="perceptionImageRevealed.next()"
      ></pcp-perception-slide>
    } @else {
      <pcp-fabric-slide-canvas
        [slide]="currentSlide"
        [layer]="fabricLayer"
        [drawingTool]="activeDrawingTool"
        [disableElementUsage]="disableElementUsage"
        [hasPreviousPage]="showPrevBookpagePageLink"
        [hasNextPage]="showNextBookpagePageLink"
        [textboardPage]="svgTextboardPageNumber"
        (previousPage)="prevBookpageClicked.next(currentSlide)"
        (nextPage)="nextBookpageClicked.next(currentSlide)"
        (textboardPageChange)="svgTextboardPageNumberChanged.next($event)"
        (hotspotClick)="hotspotClick.next($event)"
      ></pcp-fabric-slide-canvas>
    }
  }
  <!--
  VideoPlayer for all client types.
  Consumption / emission of events depends on config.
  Mutes by default on all non-presentational screens / beamer is unmuted.
  -->
  @if (
    slideTypeCategory === 'video' &&
    currentSlide &&
    currentSlide.vimeoVideoId
    ) {
    <pcp-video-player
      [vimeoPlayerDomId]="'player-' + suffix"
      [video]="currentSlide | asVideoElementInput"
      [videoControls]="disableElementUsage !== true"
      [autoplay]="true"
      [forceAutoplay]="isOpenedFromHotspot === true"
      [forceMuted]="!isPresentationScreen && isPresentationStarted"
      [responsive]="true"
      [muted]="isPresentationScreen === false"
      (hotspotClicked)="hotspotClick.next($event)"
      pcpConsumingPlayer
      [videoCommandStream$]="updateVideoInputCommand"
      (videoStartedPlaying)="videoStartedPlaying.next($event)"
      (videoPaused)="videoPaused.next($event)"
      (videoLoaded)="videoLoaded.next($event)"
      (seekedToPosition)="seekedToPosition.next($event)"
      (videoEnded)="videoEnded.next($event)"
    ></pcp-video-player>
  }
  @if (slideTypeCategory === 'interactive' && currentSlide) {
    <pcp-html-element-board
      [htmlElement]="currentSlide"
      [isPresentationScreen]="isPresentationScreen"
      [disableElementUsage]="disableElementUsage"
      [emitModifications]="emitHtmlElementModifications"
      [updateInteractiveElement]="updateInteractiveElementCommand"
      (domModified)="domModified.next($event)"
    ></pcp-html-element-board>
  }
  @if (slideTypeCategory === 'rubber' && isPresentationScreen === false) {
    <pcp-rubber-element
      [rubberImage]="rubberInput"
      [disableElementUsage]="disableElementUsage"
      (rubberElementInteraction)="rubberElementInteraction.next($event)"
    ></pcp-rubber-element>
  }
  <!-- TODO: quick&dirty fix: exclude rubber element updates on presentational screens -->
  @if (slideTypeCategory === 'rubber' && isPresentationScreen === true) {
    <pcp-rubber-element
      [disableElementUsage]="disableElementUsage"
      [rubberImage]="rubberInput"
    ></pcp-rubber-element>
  }
  @if (
    slideTypeCategory === 'difficult-question' &&
    enetToken &&
    currentSlide.qmv
    ) {
    <pcp-difficult-question-element
        [difficultQuestionElement]="{
            slideId: currentSlide.id,
            questionModuleType: currentSlide.questionModuleType,
            qmv: currentSlide.qmv,
            questionNumber: currentSlide.caption,
            guid: currentSlide.guid
        }"
      (showVideo)="showVideoForQuestionElement.next($event)"
    ></pcp-difficult-question-element>
  }
  @if (
    slideTypeCategory === 'voting' &&
    enetToken &&
    loginCode &&
    currentSlide.votingElementId
    ) {
    <pcp-voting-element
        [difficultQuestionElement]="{
            votingElementId: currentSlide.votingElementId,
            guid: currentSlide.guid,
            presentationId: presentationId,
            loginCode: loginCode
        }"
      (showVideo)="showVideoForQuestionElement.next($event)"
    ></pcp-voting-element>
  }
  @if (slideTypeCategory === 'vdo') {
    <pcp-vdo-element></pcp-vdo-element>
  }
  @if (
    isPresentationScreen === false &&
    slideTypeCategory !== 'none' &&
    slideTypeCategory !== 'difficult-question' &&
    slideTypeCategory !== 'voting' &&
    slideTypeCategory !== 'vdo' &&
    isScaleReady()
    ) {
    <app-add-to-favorites-button
      [isFavorite]="isFavorite"
      [disabled]="favoritesDisabled === true"
      [scale]="svgScale()"
      (addToFavorites)="onAddToFavoritesClicked()"
    ></app-add-to-favorites-button>
  }
  @if (copyrightNotice; as copyright) {
    <p class="copyright-notice">{{ copyright }}</p>
  }
}
